import { useState } from "react";
// import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Menu, X } from "lucide-react";
import "./style.css";
import { Button } from "../ui/button"

const Navigation = () => {
    const [isOpen, setIsOpen] = useState(false);

    const navLinks = [
        { name: "Home", href: "/" },
        { name: "Services", href: "/#services" },
        { name: "About", href: "/#about" },
        { name: "Portfolio", href: "/portfolio" },
        { name: "Contact", href: "/contact" },
		{ name: "Invoice Generator", href: "/invoice-generator" },
    ];

    return (
        <nav className="nav-container-main">
            <Helmet>
                <title>Moonface Techs | ReactJS Web Development Studio</title>
                <meta name="description" content="Moonface Techs provides high-performance ReactJS web development solutions, custom web design, and digital services for your business." />
            </Helmet>

            <div className="nav-wrapper">
                <div className="nav-inner">
                    <a href="/" className="nav-brand">
                        {/* <span className="nav-logo-box">
                            <span className="nav-logo-inner" />
                        </span> */}
                        <img src="/assets/images/halfWhiteLogoNoBG.png" alt="Moonface Techs Logo" className="nav-logo" />
                        <span className="nav-brand-text">
                            Moonface <span className="nav-brand-highlight">Techs</span>
                        </span>
                    </a>

                    {/* Desktop Navigation */}
                    <div className="nav-desktop-links">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                className="nav-link-item"
                            >
                                {link.name}
                            </a>
                        ))}
                    </div>

                    {/* Mobile menu button */}
                    <div className="nav-mobile-btn-wrapper">
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => setIsOpen(!isOpen)}
                            aria-label="Toggle menu"
                        >
                            {isOpen ? <X className="nav-icon-size" /> : <Menu className="nav-icon-size" />}
                        </Button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation */}
            {isOpen && (
                <div className="nav-mobile-dropdown">
                    <div className="nav-mobile-links-container">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                className="nav-mobile-link-item"
                                onClick={() => setIsOpen(false)}
                            >
                                {link.name}
                            </a>
                        ))}
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navigation;